module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PostSeal - quick and easy way to send letters","short_name":"PostSeal","start_url":"/","background_color":"#1890ff","theme_color":"#1890ff","display":"browser","icon":"src/images/jpg_png_4/LOGO_1_FEV.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"2b4546bdebc927150b4370b9cebfc3a5"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
